
export const environment = {
  production: true,
  backendUrl: 'https://api.prov.attentec.se',
  azTenant: 'e228a9e6-9f70-4b5e-abf6-9fbe7aa8e586',
  azClient: '19893acf-1b0c-4e29-a0ee-dd357bde43ab'
};
